import React from 'react';
import ReactDOM from 'react-dom'
import './index.css';
// import { Player } from 'video-react';
// import "video-react/dist/video-react.css";
import IdentifyModal from '../identifyModal/index'
import 'dplayer/dist/DPlayer.min.css';
import DPlayer from 'dplayer';
import { connect } from 'react-redux';
import { actionCreators } from 'labroomVideoStore';
import { getCourseInfo } from '../../../course_project/store/actionCreators';
import userRequest, {userApi} from 'common/request';
import {Redirect, Link } from 'react-router-dom';
import { Modal, Button } from 'antd-mobile';

class RoomVideo extends React.Component{
    constructor(props){
        super(props);
        this.state={
            fullScreen: false,
            findTime: false,
            dragPermission: true,
            modal: false
        }
    }
    
    async componentDidMount () {
        const {path, finishedList, courseid, sid, userid, finishedPeriod} =this.props;
        console.log(finishedPeriod.toJS(), 'finishedPeriod')
        this.dplayer = new DPlayer({
            container: document.getElementById('videodplayer'),
            video: {
                url: this.props.path
            }
        })
        
        let ua = navigator.userAgent.toLowerCase();
        let isWeixin = ua.indexOf('micromessenger') != -1;
        let isiOS =  !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        let getVideo = document.getElementsByClassName('dplayer-video')[0]
        let seekTime = finishedPeriod.toJS();
        let start = document.getElementsByClassName('dplayer-play-icon')
        if (isWeixin) {
            getVideo.setAttribute('x5-video-player-type', 'h5-page')
            getVideo.removeAttribute('playsinline')
            getVideo.removeAttribute('webkit-playsinline')
            // if(isiOS) {
            //     getVideo.removeAttribute('x5-video-player-type', 'h5-page')
            //     getVideo.setAttribute('playsinline')
            //     getVideo.setAttribute('webkit-playsinline')
            // }else {
            //     getVideo.setAttribute('x5-video-player-type', 'h5-page')
            //     getVideo.removeAttribute('playsinline')
            //     getVideo.removeAttribute('webkit-playsinline')
            // }
        }
        
        // document.getElementsByClassName('dplayer-icon dplayer-full-icon')[0].style.display = 'none'
        this.bindOnEventHandle()

        let finish = []
        finishedList.toJS().map(item => {
            if(!finish[item]) {
                finish[item] = item
            }
        })
        
        let play = finishedPeriod.toJS();
        let text = document.getElementsByClassName('dplayer-notice')[0];
        let drag = document.getElementsByClassName('dplayer-bar-wrap')[0]
        await userRequest.get( window.AppConfig.mainIP +userApi.courseDetail, {
            course_id: courseid
        }).then((res) => {
            if(res.data.information_data !== undefined && res.data &&
                res.data.information_data.allow_seek !== undefined &&
                res.data.information_data.allow_seek == "0") {
                    if(finishedPeriod.toJS().length !== 0){
                        if(sid in finish){
                            drag.style.pointerEvents = "auto"
                            // this.dplayer.seek(play[0].play_time)
                            // text.innerHTML = "上次播放到"+ this.secondToTime(play[0].play_time)
                        }else{
                            // this.dplayer.seek(play[0].play_time)
                            // text.innerHTML = "上次播放到"+ this.secondToTime(play[0].play_time)
                            drag.style.pointerEvents = "none"
                            this.setState(() => { return {dragPermission: false}})
                        }
                    }else {
                        // this.dplayer.seek(0)
                        // text.innerHTML = "上次播放到"+ this.secondToTime(0)
                        drag.style.pointerEvents = "none"
                        this.setState(() => { return {dragPermission: false}})
                    }
                }else {
                    if(finishedPeriod.toJS().length !== 0){
                        if(sid in finish){
                            // this.dplayer.seek(play[0].play_time)
                            // text.innerHTML = "上次播放到"+ this.secondToTime(play[0].play_time)
                        }else{
                            // this.dplayer.seek(play[0].play_time)
                            // text.innerHTML = "上次播放到"+ this.secondToTime(play[0].play_time)
                        }
                    }else {
                        // this.dplayer.seek(0)
                        // text.innerHTML = "上次播放到"+ this.secondToTime(0)
                    }
                }
        }).catch(err => console.log(err))

        if (!this.player) return
        console.log(ReactDOM.findDOMNode(document.getElementsByClassName('dplayerBar')), 
        'find element');

        this.player.video.subscribeToStateChange(this.handleStateChange)
    }

    secondToTime(e) {
        var t = Math.floor(e / 3600)
          , n = Math.floor((e - 3600 * t) / 60)
          , i = Math.floor(e - 3600 * t - 60 * n);
        return (t > 0 ? [t, n, i] : [n, i]).map(function(e) {
            return e < 10 ? "0" + e : "" + e
        }).join(":")
    }

    async recordSubmitForce() {
        await this.props.recordCreate({course_id: String(this.props.courseid), course_subject_id: String(this.props.sid), type: 'learn_time', learn_time: 10,force: 1,
        play_time: parseInt(this.dplayer.video.currentTime)})
    }

    sleep(t){
        return new Promise(function(resolve){
            setTimeout(resolve, t);
        })
    }

    showModal = key => (e) => {
        this.setState({
            [key]: true,
        });
    }

    onClose = key => () => {
        this.setState({
            [key]: false,
        });
    }

    bindOnEventHandle () {
        const {finishedPeriod} = this.props
        let seekTime = finishedPeriod.toJS().length == 0 ?  0 : finishedPeriod.toJS()[0].play_time
        let getVideo = document.getElementsByClassName('dplayer-video')[0]
        let text = document.getElementsByClassName('dplayer-notice')[0];
        let sid = window.location.href.slice(window.location.href.indexOf('sid')+4)
        this.dplayer.on('timeupdate', async () => {
            const initData = {
                username: JSON.parse(localStorage.getItem('userinfo')).user_name,
                tenant_code: String(localStorage.getItem('tenant_code')),
                update_at: String(parseInt(Date.now() / 1000))
            }
            if(this.state.findTime == false && seekTime !== undefined) {
                await userRequest.postRequest( window.AppConfig.courseHost + userApi.recordCreate, {course_id: String(this.props.courseid), course_subject_id: String(this.props.sid), type: 'learn_time', learn_time: 10,
                play_time: parseInt(this.dplayer.video.currentTime), ...initData})
                .then(res => {
                    console.log(res)
                    if(res.success == true && res.result.data.is_replay !== undefined && res.result.data.is_replay == true) {
                        this.showModal('modal')();
                        this.dplayer.seek(seekTime);
                        this.dplayer.pause();
                        text.innerText = "上次播放到"+ this.secondToTime(seekTime)
                    }else {
                        this.dplayer.seek(seekTime);
                        text.innerText = "上次播放到"+ this.secondToTime(seekTime)
                    }
                }).catch(err => {
                    console.log(err)
                })
                this.setState(() => {return { findTime: true}})
            }
            
    //         let sym;
    //         let that = this
    //         this.dragMonitor = setInterval(function () {
    //             if(that.state.findTime == true && this.state.dragPermission == false) {
    //                 // && this.state.dragPermission == false
    //                 var time = that.dplayer.video.currentTime
    //                 if(time-sym>3){
    //                    that.dplayer.seek(sym)
    //                 }
    //                 sym=that.dplayer.video.currentTime
    //             }
    //         },2000);
        })

        // getVideo.addEventListener('timeupdate', ()=> {
        //     if(this.state.findTime == false && seekTime !== undefined) {
        //         text.innerHTML = "上次播放到"+ this.secondToTime(seekTime)
        //         getVideo.currentTime = seekTime
        //         this.setState(() => {return { findTime: true}})
        //     }
        // })

        this.dplayer.on('play', () => {
            this.timer = window.setInterval(async () => {
                const initData = {
                    username: JSON.parse(localStorage.getItem('userinfo')).user_name,
                    tenant_code: String(localStorage.getItem('tenant_code')),
                    update_at: +String(parseInt(Date.now() / 1000))
                }
                await userRequest.postRequest( window.AppConfig.courseHost + userApi.recordCreate, {course_id: String(this.props.courseid), course_subject_id: String(this.props.sid), type: 'learn_time', learn_time: 10,
                    play_time: parseInt(this.dplayer.video.currentTime), ...initData})
                    .then(res => {
                        console.log(res)
                        if(res.success == true && res.result.data.is_pop !== undefined && res.result.data.is_pop == true) {
                            this.dplayer.pause()
                            window.clearInterval(this.timer)
                            return window.location.replace(`/identify/${sid}/${this.props.courseid}/${encodeURIComponent(window.location.href)}/`)
                        }
                    }).catch(err => {
                        console.log(err)
                    })
            }, 10000)

        })

        this.dplayer.on('pause',() => {
            if (this.timer) window.clearInterval(this.timer)
            // if(this.dragMonitor) window.clearInterval(this.dragMonitor)
            this.recordSubmitForce();
        })

        this.dplayer.on('ended',() => {
            if (this.timer) window.clearInterval(this.timer)
            // if(this.dragMonitor) window.clearInterval(this.dragMonitor)
            document.location.replace(window.location.href)
        })
    }

    handleStateChange = (state, prevState) => {
        if (!state.paused&&prevState.paused) {
            this.timer = window.setInterval(() => {
                this.props.recordCreate({course_id: String(this.props.courseid), course_subject_id: String(this.props.sid), type: 'learn_time', learn_time: 10})
            }, 10000)
        }else if (state.paused) {
            if (this.timer) window.clearInterval(this.timer)
            // if(this.dragMonitor) window.clearInterval(this.dragMonitor)
        }
    }

    render(){
    return (
      <div>
        {/* <IdentifyModal ref="idChild"></IdentifyModal> */}
        <div className="video-player">
            {/*<Player ref={(player) => { this.player = player }} className='videoPlayer' playsInline  src={path} width={100}/>*/}
            <div id="videodplayer"></div>
        </div>
        <Modal
          visible={this.state.modal}
          transparent
          maskClosable={false}
          title="提醒"
          style={{ position: 'sticky'}}>
              <div style={{ height: '90%', overflow: 'scroll' }}>
                  <div className="condition">
                      <span className="co-des-title margin">上次认证失败，播放进度置为零</span>
                      <button className="submit-return" onClick={this.onClose('modal')}>确定</button>
                  </div>
              </div>
          </Modal>
      </div>
      )
    }
}

const mapDispatch = (dispatch) => ({
    getFinishedPlaytime(course_id, user_id, sub_id){
        dispatch(actionCreators.getFinishedPlaytime(course_id, user_id, sub_id))
    },
    getFinishedCourse(course_id, user_id) {
        dispatch(actionCreators.getFinishedCourse(course_id, user_id))
    }
})

const mapState = (state) => ({
    finishedPeriod: state.getIn(['labroomvideo', 'finishedPeriod']),
    pop: state.getIn(['labroomvideo', 'pop'])
})

export default connect(mapState, mapDispatch)(RoomVideo);

